// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__1Jb4j","head":"ProcedureTableInfo_head__2nw2z"};